export default "__VITE_ASSET__BcHV7af$__"